import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { BoostPlacementTarget } from './boost-placement-target-container';

export const placementTargetingDetails = ({ BoostAdunitIds, i18n }) => {
  if (!BoostAdunitIds || (_.isArray(BoostAdunitIds) && BoostAdunitIds.length === 0)) {
    return i18n.getString(_TL_('No placements selected'));
  } else if (BoostAdunitIds.split(';').length === 1) {
    return i18n.getString(_TL_('1 placement selected'));
  }
  return i18n.getString(_TL_('{{ count }} placements selected'), { count: BoostAdunitIds.split(';').length });
};

export const contextualTargetDetails = ({ contextualTargets, i18n }) => {
  if (!contextualTargets) {
    return i18n.getString(_TL_('No contextual targets selected'));
  } else if (contextualTargets.length === 0) {
    return i18n.getString(_TL_('No contextual targets selected'));
  } else if (contextualTargets.length === 1) {
    return i18n.getString(_TL_('1 contextual target selected'));
  }
  return i18n.getString(_TL_('{{ count }} contextual targets selected'), { count: contextualTargets.length });
};

export const ValidatedBoostPlacementTargetInternal = ({
  updateValidation,
  ...rest
}) => {
  const onDataChange = (result) => {
    updateValidation([], { ...result });
  };

  return (
    <BoostPlacementTarget
      onDataChange={onDataChange}
      {...rest}
    />
  );
};

ValidatedBoostPlacementTargetInternal.propTypes = {
  i18n: PropTypes.shape({}).isRequired,
  updateValidation: PropTypes.func.isRequired,
};

export const ValidatedBoostPlacementTarget = withCustomValidation(ValidatedBoostPlacementTargetInternal);
